// extracted by css-extract-rspack-plugin
module.exports =  {"root":"CommunicationView__root___Ebdz_","callHost":"CommunicationView__callHost___Ck8vs","activeCallRoot":"CommunicationView__activeCallRoot___ebbTf"};